import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export const markOptimizationNotificationsRead = async ({
  optimizationId,
  notificationIds,
}: {
  optimizationId: string;
  notificationIds: string[];
}): Promise<void> => {
  const response = await api.optimizations.markNotificationsAsRead.mutation({
    params: { id: optimizationId },
    body: { notificationIds },
  });

  if (response.status !== 200) {
    throw new ApiError(
      "Error marking optimization notifications as read",
      response.status,
      response.body,
    );
  }
};
